import { withStyles, Button } from '@material-ui/core';
import {ArrowBackSharp} from '@material-ui/icons';
const styles = (theme) => ({
  dialogActionStyle: {
    display: 'flex',
    marginBottom: 16,
    paddingTop:12,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rightGroup: {
    display: 'flex',
    gap: 8,
  },
  dialogButtonStyle: {
    fontSize: theme.textFontSize,
    textTransform: 'none',
    borderRadius: '2px',
    width: '60px',
    '&$disabledButton,&$disabledButton:hover': {
      cursor: 'not-allowed',
      pointerEvents: 'all',
      backgroundColor: theme.customInputBGColor,
      color: theme.white
    }
  },
  tertiaryBack: {
    textTransform: 'none',
    padding: 0,
    minWidth: 0,
  },
  dialogPrimary:{
    marginLeft: 8

  },
  disabledButton: {
    cursor: 'not-allowed',
    pointerEvents: 'all',
    backgroundColor: theme.iconColor,
    color: theme.white
  }
});

const Action = (props) => {
  const {
    classes,
    isLoading = false,
    onClick = null,    
    onClose = null,
    hideUpdateAction = false,
    hideCloseAction = false
  } = props;

  return (
    <div className={classes.dialogActionStyle}>
      {!hideCloseAction && (
        <Button
          id="back-to-all-customers"
          onClick={onClose}
          color="primary"
          className={classes.tertiaryBack}
          size="small"
        >
          <ArrowBackSharp 
            style={{
              marginRight: 6,
              fontSize:'large',
            }} 
          />
          <span style={{ fontWeight: 'bold' }}>
            Back to All Customers
          </span>
        </Button>
      )}
      <div className={classes.rightGroup}>
        {!hideUpdateAction && (
          <Button
            id="update"
            disabled={isLoading}
            onClick={onClick}
            color="primary"
            variant="contained"
            classes={{
              root:`${classes.dialogButtonStyle} ${classes.dialogPrimary}` ,
              disabled: classes.disabledButton
            }}>
            Update
          </Button>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Action);
